module.exports = __webpack_public_path__ + "static/media/hard_dollars_1.891e7bbc.png";